import type { BankListDto } from '@pickthebank/api-sdk';
import { useTranslation } from 'next-i18next';
import Link from 'next-translate-routes/link';
import { useRouter } from 'next-translate-routes/router';
import type { FC } from 'react';

import { BankImage, Icon } from '@/components';
import { COUNTRIES_PATHS } from '@/utils/countries';

interface BanksListItemProps {
  bank: BankListDto;
}

export const BanksListItem: FC<BanksListItemProps> = ({ bank }) => {
  const { locale } = useRouter();
  const { t } = useTranslation();
  const renderContent = () => (
    <>
      <div className="flex w-full min-w-0 items-center justify-between gap-6 lg:max-w-[unset]">
        <div className="flex items-center overflow-hidden">
          <BankImage bankIndex={bank.index} className="size-10" />
          <div className="ml-3 overflow-hidden">
            <p className="body2-bold truncate tracking-[0.2px] text-blue-900 xl:w-[464px]">
              {bank.name}
            </p>
            <p className="body3 shrink-0 tracking-[0.2px] text-grey-600 md:hidden">
              {t(`database.countries.${bank.country.name}`)}
            </p>
          </div>
        </div>
        <p className="body2 hidden shrink-0 tracking-[0.2px] text-grey-800 md:block lg:w-[240px]">
          {t(`database.countries.${bank.country.name}`)}
        </p>
      </div>
      <Icon
        name="chevron"
        className="block size-5 shrink-0 rotate-90 text-grey-400"
      />
    </>
  );

  return (
    <li className="w-full py-4">
      {bank.slug ? (
        <Link
          className="flex items-center justify-between gap-6"
          href={{
            pathname: `/banks/${COUNTRIES_PATHS[bank.country.name][locale || 'en']}/${bank.slug}`,
          }}
        >
          {renderContent()}
        </Link>
      ) : (
        <div className="flex items-center justify-between gap-6">
          {renderContent()}
        </div>
      )}
    </li>
  );
};
